import React, { useState, useEffect } from "react";
import { Modal, Button, Form, Card, Row, Col } from "react-bootstrap";
import axios from "axios";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { var_api } from "../../../constant";
import { useNavigate } from "react-router-dom";

const WastageMaster = () => {
  const tableHeaders = ["#", "Wastage Number", "Date", "Reason Type", "Remarks", "Created By", "Action"];
  const [wastageData, setWastageData] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [isEditMode, setIsEditMode] = useState(false);
  const [loading, setLoading] = useState(false);
  const [initialLoading, setInitialLoading] = useState(true);
  const [errors, setErrors] = useState({});
  const [searchQuery, setSearchQuery] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 15;
    const navigate = useNavigate();

  const userId = localStorage.getItem("user_id");
  const userName = localStorage.getItem("name");

  const [formData, setFormData] = useState({
    id: null,
    warehouse_id: 1,
    wastage_number: "",
    wastage_date: "",
    reason_type: "",
    remarks: "",
    created_by: userId || "",
  });

  useEffect(() => {
    fetchWastage();
  }, []);

  const fetchWastage = async () => {
    try {
      setInitialLoading(true);
      const res = await axios.get(`${var_api}veemart_warehouse_wastage_transaction/get`);
      setWastageData(res.data || []);
    } catch (err) {
      console.error("Failed to fetch wastage data", err);
    } finally {
      setInitialLoading(false);
    }
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
    setErrors((prev) => ({ ...prev, [name]: "" }));
  };

  const handleAddClick = () => {
    setFormData({
      id: null,
      warehouse_id: 1,
      wastage_number: "",
      wastage_date: "",
      reason_type: "",
      remarks: "",
      created_by: userId || "",
    });
    setIsEditMode(false);
    setErrors({});
    setShowModal(true);
  };

 const handleEditClick = (item) => {
  const formattedDate = item.wastage_date
    ? new Date(item.wastage_date).toISOString().split("T")[0]
    : "";

  setFormData({
    id: item.id,
    warehouse_id: item.warehouse_id || 1,
    wastage_number: item.wastage_number || "",
    wastage_date: formattedDate, // ✅ Correct key
    reason_type: item.reason_type || "",
    remarks: item.remarks || "",
    created_by: userId || "",
  });

  setIsEditMode(true);
  setErrors({});
  setShowModal(true);
};


  const handleSubmit = async (e) => {
    e.preventDefault();

    const newErrors = {};
    if (!formData.wastage_number.trim()) newErrors.wastage_number = "Wastage number is required";
    if (!formData.wastage_date) newErrors.wastage_date = "Wastage date is required";
    if (!formData.reason_type) newErrors.reason_type = "Reason type is required";

    setErrors(newErrors);
    if (Object.keys(newErrors).length > 0) {
      toast.warning("Please correct the highlighted fields");
      return;
    }

    setLoading(true);
    try {
      let res;
      if (isEditMode && formData.id) {
        res = await axios.put(`${var_api}veemart_warehouse_wastage_transaction/update/${formData.id}`, formData);
      } else {
        res = await axios.post(`${var_api}veemart_warehouse_wastage_transaction/post`, formData);
      }

      toast.success(res?.data?.message || "Wastage saved successfully");
      setShowModal(false);
      fetchWastage();
    } catch (err) {
      console.error("Error saving wastage:", err);
      toast.error(err?.response?.data?.message || "Error occurred while saving");
    } finally {
      setLoading(false);
    }
  };

  const reasonTypeLabel = (type) => {
    switch (Number(type)) {
      case 1:
        return "Expired";
      case 2:
        return "Damaged";
      case 3:
        return "Broken";
      case 4:
        return "Others";
      default:
        return "-";
    }
  };
  const formatDate = (dateString) => {
  if (!dateString) return "-";
  const date = new Date(dateString);
  const day = String(date.getDate()).padStart(2, "0");
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const year = date.getFullYear();
  return `${day}-${month}-${year}`;
};


 const filteredData = wastageData.filter((item) => {
  const search = searchQuery.toLowerCase();

  // Convert reason_type number to its label for better search
  const reason = reasonTypeLabel(item.reason_type).toLowerCase();

  return (
    (item.wastage_number && item.wastage_number.toLowerCase().includes(search)) ||
    (item.remarks && item.remarks.toLowerCase().includes(search)) ||
    (reason && reason.includes(search)) ||
    (formatDate(item.wastage_date).includes(search))
  );
});


  const totalPages = Math.ceil(filteredData.length / itemsPerPage);
  const paginatedData = filteredData.slice((currentPage - 1) * itemsPerPage, currentPage * itemsPerPage);

  return (
    <>
      <Card>
        <Card.Body>
          {initialLoading ? (
            <div className="text-center my-5">
              <div className="spinner-border text-primary" role="status"></div>
              <div>Loading data...</div>
            </div>
          ) : (
            <>
              <div className="d-flex justify-content-end mb-3 gap-2">
                <input
                  type="text"
                  className="form-control w-auto"
                  placeholder="Search wastage..."
                  value={searchQuery}
                  onChange={(e) => {
                    setSearchQuery(e.target.value);
                    setCurrentPage(1);
                  }}
                />
                <Button variant="secondary" onClick={handleAddClick}>
                  Add
                </Button>
              </div>

              <div className="table-responsive">
                <table className="table">
                  <thead>
                    <tr>
                      {tableHeaders.map((header, idx) => (
                        <th key={idx}>{header}</th>
                      ))}
                    </tr>
                  </thead>
                  <tbody>
                    {paginatedData.length === 0 ? (
                      <tr>
                        <td colSpan="7" className="text-center text-muted py-3">
                          No data found
                        </td>
                      </tr>
                    ) : (
                      paginatedData.map((item, idx) => (
                        <tr key={item.id}>
                          <td>{(currentPage - 1) * itemsPerPage + idx + 1}</td>
                          <td>{item.wastage_number}</td>
                                                   <td>{formatDate(item.wastage_date)}</td>

                          <td>{reasonTypeLabel(item.reason_type)}</td>
                          <td>{item.remarks || "-"}</td>
                          <td>{userName || "-"}</td>
                          <td>
                            <button
                              className="btn shadow btn-xs sharp"
                              style={{ backgroundColor: "#007bff", color: "white" }}
                              onClick={() => handleEditClick(item)}
                              title="Edit"
                            >
                              <i className="
                              fas fa-pencil-alt"></i>
                            </button>
                               <button
                              className="btn shadow btn-xs sharp"
                              style={{ backgroundColor: "#28a745", color: "white" }}
                              title="View details "
                              onClick={() => {
                                localStorage.setItem("wastage_id", item.id);
                                localStorage.setItem("wastage_date", item.wastage_date);
                                localStorage.setItem("reason_type", item.reason_type);

                                navigate(`/wastage-details?wastage_id=${encodeURIComponent(item.id)}`);
                              }}
                            >
                              <i className="fas fa-cubes"></i>
                            </button>
                          </td>
                        </tr>
                      ))
                    )}
                  </tbody>
                </table>

                <div className="d-flex justify-content-end mt-3">
                  {[...Array(totalPages)].map((_, idx) => (
                    <Button
                      key={idx}
                      variant={currentPage === idx + 1 ? "primary" : "light"}
                      onClick={() => setCurrentPage(idx + 1)}
                      className="me-1"
                    >
                      {idx + 1}
                    </Button>
                  ))}
                </div>
              </div>
            </>
          )}
        </Card.Body>
      </Card>

      {/* Modal */}
      <Modal show={showModal} onHide={() => setShowModal(false)} size="lg" centered>
        <Modal.Header closeButton>
          <Modal.Title>{isEditMode ? "Edit Wastage" : "Add Wastage"}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form onSubmit={handleSubmit}>
            <Row>
              <Col md={6}>
                <Form.Group className="mb-3">
                  <Form.Label>
                    Wastage Number <span className="text-danger">*</span>
                  </Form.Label>
                  <Form.Control
                    type="text"
                    name="wastage_number"
                    value={formData.wastage_number}
                    placeholder="Enter Wastage Number"
                    onChange={handleInputChange}
                    isInvalid={!!errors.wastage_number}
                  />
                  <Form.Control.Feedback type="invalid">
                    {errors.wastage_number}
                  </Form.Control.Feedback>
                </Form.Group>
              </Col>

              <Col md={6}>
                <Form.Group className="mb-3">
                  <Form.Label>
                    Wastage Date <span className="text-danger">*</span>
                  </Form.Label>
                  <Form.Control
                    type="date"
                    name="wastage_date"
                    value={formData.wastage_date}
                    onChange={handleInputChange}
                    isInvalid={!!errors.wastage_date}
                  />
                  <Form.Control.Feedback type="invalid">
                    {errors.wastage_date}
                  </Form.Control.Feedback>
                </Form.Group>
              </Col>
            </Row>

            <Row>
              <Col md={6}>
                <Form.Group className="mb-3">
                  <Form.Label>
                    Reason Type <span className="text-danger">*</span>
                  </Form.Label>
                  <Form.Select
                    name="reason_type"
                    value={formData.reason_type}
                    onChange={handleInputChange}
                    isInvalid={!!errors.reason_type}
                  >
                    <option value="">Select Reason</option>
                    <option value="1">Expired</option>
                    <option value="2">Damaged</option>
                    <option value="3">Broken</option>
                    <option value="4">Others</option>
                  </Form.Select>
                  <Form.Control.Feedback type="invalid">
                    {errors.reason_type}
                  </Form.Control.Feedback>
                </Form.Group>
              </Col>

              <Col md={6}>
                <Form.Group className="mb-3">
                  <Form.Label>Remarks</Form.Label>
                  <Form.Control
                    as="textarea"
                    rows={2}
                    name="remarks"
                    value={formData.remarks}
                    placeholder="Enter Remarks"
                    onChange={handleInputChange}
                  />
                </Form.Group>
              </Col>
            </Row>

            <div className="d-flex justify-content-end gap-2">
              <Button variant={isEditMode ? "warning" : "secondary"} type="submit" disabled={loading}>
                {loading ? (
                  <>
                    <span
                      className="spinner-border spinner-border-sm me-2"
                      role="status"
                      aria-hidden="true"
                    ></span>
                    {isEditMode ? "Updating..." : "Creating..."}
                  </>
                ) : isEditMode ? (
                  "Update"
                ) : (
                  "Create"
                )}
              </Button>
              <Button variant="danger" onClick={() => setShowModal(false)} disabled={loading}>
                Cancel
              </Button>
            </div>
          </Form>
        </Modal.Body>
      </Modal>

      <ToastContainer />
    </>
  );
};

export default WastageMaster;
